class BBuyBar extends HTMLElement {
  connectedCallback() {
    const id = this.dataset.sectionId;
    this.submit = document.getElementById(`ProductSubmitButton-${id}`);
    this.priceRoot = () => document.getElementById(`price-${id}`);
    if (!this.submit) return;

    // Posición en cada scroll (rAF): un IntersectionObserver no se dispara si un salto
    // de scroll lleva el botón de debajo a encima de la vista sin cruzarla.
    this.ticking = false;
    this.onScroll = () => {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.classList.toggle('is-visible', this.submit.getBoundingClientRect().bottom < 0);
        this.ticking = false;
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();

    this.querySelector('[data-buybar-add]').addEventListener('click', () => this.submit.click());

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== id) return;
        requestAnimationFrame(() => this.sync());
      });
    }
  }

  sync() {
    const root = this.priceRoot();
    if (!root) return;
    const price = root.querySelector('[data-current-price]')?.textContent.trim();
    const size = root.querySelector('[data-current-size]')?.textContent.trim();
    const available = root.querySelector('[data-current-available]')?.textContent.trim() === 'true';
    if (price) this.querySelector('[data-buybar-price]').textContent = price;
    if (size) this.querySelector('[data-buybar-size]').textContent = size;
    this.querySelector('[data-buybar-add]').disabled = !available;
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.unsubscribe?.();
  }
}
if (!customElements.get('b-buy-bar')) customElements.define('b-buy-bar', BBuyBar);
